module.exports = __webpack_public_path__ + "img/icon_network.b57d6562.svg";